let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a9YcI")).then(() => parcelRequire('1f61U'));